import {
  FornitoreDettagliato,
  FornitoreBase,
  ApiResponse,
  MockResponse,
  LookupData,
  MenuItem,
} from "./types";

/**
 * Dati mock dettagliati per i fornitori
 */
export const FORNITORI_DETTAGLIATI: FornitoreDettagliato[] = [
  {
    id: 1,
    operatore_economico: {
      stato: "Italia",
      possiede_partita_iva: true,
      partita_iva: "11141801008",
      codice_fiscale_ditta: "11141801008",
      id_soggetto: null,
    },
    azienda: {
      denominazione: "MARCELLO GEPPETTI MEDIA COMPANY S.R.L.",
      ragione_sociale: "MARCELLO GEPPETTI MEDIA COMPANY S.R.L.",
      forma_giuridica: "Società a responsabilità limitata",
      indirizzo: "VIA DEI SALENTINI 26",
      comune: "Roma",
      provincia: "Roma",
      regione: "Lazio",
      cap: "00185",
      sedi_secondarie: null,
      email_pec: "INFO@PEC.MARCELLOGEPPETTI.COM",
      telefono: "06-12345678",
      fax: "06-12345679",
      stato_attivita: "Attiva",
      codice_ateco: "70.21.00",
      codice_ateco_2025: "70.21.00",
      ateco_testo: "Pubbliche relazioni e comunicazione",
      ateco_2025_testo: "Pubbliche relazioni e comunicazione",
      anno_iscrizione_cciaa: 2012,
      numero_rea: "1283045",
      cciaa_di: "RM",
      codice_eori: "IT11141801008",
      etichette: ["Media", "Comunicazione", "Marketing"],
    },
    referente_legale: {
      nome: "CAMILLA",
      cognome: "MACRO",
      telefono_1: "335-1234567",
      telefono_2: null,
      email: "c.macro@marcellogeppetti.com",
      qualifica: "AMMINISTRATORE UNICO",
      codice_fiscale: "MCRCLL78A45H501E",
    },
    rating_rischio: {
      cerved_group_score: 7.2,
      score_sintetico: "BB+",
      score_tempi_pagamento: "Regolare",
      consistenza_immobiliare: "Media",
      situazione_economico_finanziaria: "Buona",
      profilo_strutturale: "Solido",
      rischio_connesso_num_consultazioni: "Basso",
      eventi_negativi: "Nessuno",
      cgs_valore: 72,
      cgr_classe: "2",
      cgr_descrizione: "Rischio contenuto",
      rischio_interno: "Basso",
      variazione_rischio_interno: "Stabile",
    },
    dati_economici: {
      fatturato_000_eur: 2850,
      mol_000_eur: 425,
      margine_gestione_finanziaria_000_eur: 380,
      ebitda_000_eur: 425,
      utile_perdita_000_eur: 156,
      attivo_000_eur: 1200,
      passivo_000_eur: 800,
      dipendenti: 15,
      anno_riferimento_dati_economici: 2023,
      fatturato_12m: 2850000,
      media_fatturato: 2650000,
      fatturato_mese: 237500,
      incassato: 2700000,
      classe_di_fatturato: "2-5M",
      mese_riferimento_dati_caricati: 12,
      anno_riferimento_dati_caricati: 2023,
    },
    monitoraggio: {
      prodotto: "Standard Monitoring",
      scadenza_monitoraggio: "2024-12-31",
      utenza: "monitoring@sistema.it",
    },
    credito_commerciale: {
      fido: 50000,
      fido_commerciale: 45000,
      fido_dinamico: 48000,
      fido_dinamico_medio: 46500,
      variazione_fido_commerciale_vs_dinamico_medio: 3.2,
      azione_da_fido_dinamico: "Mantenere",
      fido_2: null,
      esposizione: 25000,
      scaduto: 0,
      esposizione_su_fido_commerciale: 55.6,
      dso: 45,
      dso_medio: 42,
      bp_dso: 38,
      bp_dso_medio: 40,
      add: 35,
      add_medio: 32,
      limite_dso: 60,
      condizione_di_pagamento: "30 giorni data fattura",
      giorni_nominali: 30,
      codice_cliente_interno: "FORN001",
    },
    categorie_internal_use: {
      cat1: "Media",
      cat2: "Strategico",
      cat3: "Nazionale",
      cat4: null,
      cat5: null,
      cat6: null,
      cat7: null,
      cat8: null,
    },
    pagamenti: {
      iban: "IT60X0542811101000000123456",
      sdi: "ABC1234",
      metodo_pagamento_preferito: "Bonifico bancario",
      note: "Pagamenti sempre puntuali",
    },
    metadati: {
      fonte: "Portale Fornitori Privato",
      versione_schema: "1.1.0",
      data_creazione: "2023-01-15",
      data_ultima_modifica: "2024-10-30",
    },
  },
  {
    id: 2,
    operatore_economico: {
      stato: "Italia",
      possiede_partita_iva: true,
      partita_iva: "09876543210",
      codice_fiscale_ditta: "09876543210",
      id_soggetto: null,
    },
    azienda: {
      denominazione: "TECH SOLUTIONS ITALIA S.P.A.",
      ragione_sociale: "TECH SOLUTIONS ITALIA S.P.A.",
      forma_giuridica: "Società per azioni",
      indirizzo: "VIA MILANO 150",
      comune: "Milano",
      provincia: "Milano",
      regione: "Lombardia",
      cap: "20100",
      sedi_secondarie: "Roma, Torino",
      email_pec: "INFO@PEC.TECHSOLUTIONS.IT",
      telefono: "02-87654321",
      fax: "02-87654322",
      stato_attivita: "Attiva",
      codice_ateco: "62.01.00",
      codice_ateco_2025: "62.01.00",
      ateco_testo: "Produzione di software non connesso all'edizione",
      ateco_2025_testo: "Produzione di software non connesso all'edizione",
      anno_iscrizione_cciaa: 2008,
      numero_rea: "1856742",
      cciaa_di: "MI",
      codice_eori: "IT09876543210",
      etichette: ["IT", "Software", "Consulenza", "Enterprise"],
    },
    referente_legale: {
      nome: "MARCO",
      cognome: "BERNARDI",
      telefono_1: "340-9876543",
      telefono_2: "02-87654323",
      email: "m.bernardi@techsolutions.it",
      qualifica: "AMMINISTRATORE DELEGATO",
      codice_fiscale: "BRNMRC75M15F205X",
    },
    rating_rischio: {
      cerved_group_score: 8.5,
      score_sintetico: "A-",
      score_tempi_pagamento: "Ottimo",
      consistenza_immobiliare: "Elevata",
      situazione_economico_finanziaria: "Ottima",
      profilo_strutturale: "Molto solido",
      rischio_connesso_num_consultazioni: "Molto basso",
      eventi_negativi: "Nessuno",
      cgs_valore: 85,
      cgr_classe: "1",
      cgr_descrizione: "Rischio minimo",
      rischio_interno: "Molto basso",
      variazione_rischio_interno: "Miglioramento",
    },
    dati_economici: {
      fatturato_000_eur: 15200,
      mol_000_eur: 3800,
      margine_gestione_finanziaria_000_eur: 3650,
      ebitda_000_eur: 3800,
      utile_perdita_000_eur: 1250,
      attivo_000_eur: 8500,
      passivo_000_eur: 4200,
      dipendenti: 85,
      anno_riferimento_dati_economici: 2023,
      fatturato_12m: 15200000,
      media_fatturato: 13800000,
      fatturato_mese: 1266667,
      incassato: 14950000,
      classe_di_fatturato: "10-50M",
      mese_riferimento_dati_caricati: 12,
      anno_riferimento_dati_caricati: 2023,
    },
    monitoraggio: {
      prodotto: "Premium Monitoring",
      scadenza_monitoraggio: "2025-06-30",
      utenza: "premium@sistema.it",
    },
    credito_commerciale: {
      fido: 200000,
      fido_commerciale: 180000,
      fido_dinamico: 195000,
      fido_dinamico_medio: 185000,
      variazione_fido_commerciale_vs_dinamico_medio: 2.7,
      azione_da_fido_dinamico: "Incrementare",
      fido_2: 220000,
      esposizione: 125000,
      scaduto: 0,
      esposizione_su_fido_commerciale: 69.4,
      dso: 35,
      dso_medio: 32,
      bp_dso: 28,
      bp_dso_medio: 30,
      add: 25,
      add_medio: 27,
      limite_dso: 45,
      condizione_di_pagamento: "30 giorni fine mese",
      giorni_nominali: 30,
      codice_cliente_interno: "FORN002",
    },
    categorie_internal_use: {
      cat1: "IT",
      cat2: "Strategico",
      cat3: "Internazionale",
      cat4: "Premium",
      cat5: null,
      cat6: null,
      cat7: null,
      cat8: null,
    },
    pagamenti: {
      iban: "IT60X0300203280284975845781",
      sdi: "XYZ9876",
      metodo_pagamento_preferito: "Bonifico SEPA",
      note: "Cliente premium con condizioni preferenziali",
    },
    metadati: {
      fonte: "Portale Fornitori Privato",
      versione_schema: "1.1.0",
      data_creazione: "2023-03-20",
      data_ultima_modifica: "2024-10-29",
    },
  },
  {
    id: 3,
    operatore_economico: {
      stato: "Italia",
      possiede_partita_iva: true,
      partita_iva: "11223344556",
      codice_fiscale_ditta: "11223344556",
      id_soggetto: null,
    },
    azienda: {
      denominazione: "GAMMA ENGINEERING S.R.L.",
      ragione_sociale: "GAMMA ENGINEERING S.R.L.",
      forma_giuridica: "Società a responsabilità limitata",
      indirizzo: "VIA NAPOLI 789",
      comune: "Napoli",
      provincia: "Napoli",
      regione: "Campania",
      cap: "80100",
      sedi_secondarie: null,
      email_pec: "GAMMA@PEC.IT",
      telefono: "081-1122334",
      fax: "081-1122335",
      stato_attivita: "Sospesa temporaneamente",
      codice_ateco: "71.12.10",
      codice_ateco_2025: "71.12.10",
      ateco_testo: "Attività degli studi di ingegneria",
      ateco_2025_testo: "Attività degli studi di ingegneria",
      anno_iscrizione_cciaa: 2015,
      numero_rea: "654321",
      cciaa_di: "NA",
      codice_eori: null,
      etichette: ["Ingegneria", "Edile", "Civile"],
    },
    referente_legale: {
      nome: "GIUSEPPE",
      cognome: "VERDI",
      telefono_1: "348-1122334",
      telefono_2: null,
      email: "g.verdi@gamma.com",
      qualifica: "AMMINISTRATORE UNICO",
      codice_fiscale: "VRDGPP70A15F839Y",
    },
    rating_rischio: {
      cerved_group_score: 4.8,
      score_sintetico: "CCC",
      score_tempi_pagamento: "Irregolare",
      consistenza_immobiliare: "Bassa",
      situazione_economico_finanziaria: "Critica",
      profilo_strutturale: "Debole",
      rischio_connesso_num_consultazioni: "Elevato",
      eventi_negativi: "Protesti, Procedure",
      cgs_valore: 48,
      cgr_classe: "4",
      cgr_descrizione: "Rischio elevato",
      rischio_interno: "Alto",
      variazione_rischio_interno: "Peggioramento",
    },
    dati_economici: {
      fatturato_000_eur: 850,
      mol_000_eur: -45,
      margine_gestione_finanziaria_000_eur: -65,
      ebitda_000_eur: -45,
      utile_perdita_000_eur: -125,
      attivo_000_eur: 450,
      passivo_000_eur: 620,
      dipendenti: 8,
      anno_riferimento_dati_economici: 2023,
      fatturato_12m: 850000,
      media_fatturato: 1200000,
      fatturato_mese: 70833,
      incassato: 680000,
      classe_di_fatturato: "0.5-2M",
      mese_riferimento_dati_caricati: 12,
      anno_riferimento_dati_caricati: 2023,
    },
    monitoraggio: {
      prodotto: "Alert Monitoring",
      scadenza_monitoraggio: "2024-03-31",
      utenza: "alert@sistema.it",
    },
    credito_commerciale: {
      fido: 15000,
      fido_commerciale: 10000,
      fido_dinamico: 8000,
      fido_dinamico_medio: 12000,
      variazione_fido_commerciale_vs_dinamico_medio: -16.7,
      azione_da_fido_dinamico: "Ridurre drasticamente",
      fido_2: null,
      esposizione: 18000,
      scaduto: 12000,
      esposizione_su_fido_commerciale: 180.0,
      dso: 85,
      dso_medio: 78,
      bp_dso: 95,
      bp_dso_medio: 82,
      add: 105,
      add_medio: 95,
      limite_dso: 30,
      condizione_di_pagamento: "Pagamento anticipato",
      giorni_nominali: 0,
      codice_cliente_interno: "FORN003",
    },
    categorie_internal_use: {
      cat1: "Ingegneria",
      cat2: "Rischio",
      cat3: "Locale",
      cat4: "Monitoraggio",
      cat5: null,
      cat6: null,
      cat7: null,
      cat8: null,
    },
    pagamenti: {
      iban: "IT60X0542811101000000789012",
      sdi: "GHI9012",
      metodo_pagamento_preferito: "Contanti",
      note: "Attenzione: Difficoltà finanziarie. Richiedere pagamento anticipato",
    },
    metadati: {
      fonte: "Portale Fornitori Privato",
      versione_schema: "1.1.0",
      data_creazione: "2023-03-10",
      data_ultima_modifica: "2024-10-30",
    },
  },
  {
    id: 4,
    operatore_economico: {
      stato: "Italia",
      possiede_partita_iva: true,
      partita_iva: "99887766554",
      codice_fiscale_ditta: "RSSMRA80A01H501Z",
      id_soggetto: null,
    },
    azienda: {
      denominazione: "Mario Rossi",
      ragione_sociale: "Mario Rossi",
      forma_giuridica: "Ditta individuale",
      indirizzo: "Via Torino 321",
      comune: "Torino",
      provincia: "Torino",
      regione: "Piemonte",
      cap: "10100",
      sedi_secondarie: null,
      email_pec: "mario.rossi@pec.it",
      telefono: "011-9988776",
      fax: null,
      stato_attivita: "Attiva",
      codice_ateco: "69.20.20",
      codice_ateco_2025: "69.20.20",
      ateco_testo: "Consulenza fiscale e tributaria",
      ateco_2025_testo: "Consulenza fiscale e tributaria",
      anno_iscrizione_cciaa: 2015,
      numero_rea: null,
      cciaa_di: "TO",
      codice_eori: null,
      etichette: ["Consulenza", "Fiscale", "Tributaria"],
    },
    referente_legale: {
      nome: "MARIO",
      cognome: "ROSSI",
      telefono_1: "333-9988776",
      telefono_2: null,
      email: "mario.rossi@email.com",
      qualifica: "TITOLARE",
      codice_fiscale: "RSSMRA80A01H501Z",
    },
    rating_rischio: {
      cerved_group_score: 6.8,
      score_sintetico: "BB",
      score_tempi_pagamento: "Regolare",
      consistenza_immobiliare: "Bassa",
      situazione_economico_finanziaria: "Buona",
      profilo_strutturale: "Solido",
      rischio_connesso_num_consultazioni: "Basso",
      eventi_negativi: "Nessuno",
      cgs_valore: 68,
      cgr_classe: "2",
      cgr_descrizione: "Rischio contenuto",
      rischio_interno: "Basso",
      variazione_rischio_interno: "Stabile",
    },
    dati_economici: {
      fatturato_000_eur: 180,
      mol_000_eur: 45,
      margine_gestione_finanziaria_000_eur: 42,
      ebitda_000_eur: 45,
      utile_perdita_000_eur: 28,
      attivo_000_eur: 85,
      passivo_000_eur: 35,
      dipendenti: 1,
      anno_riferimento_dati_economici: 2023,
      fatturato_12m: 180000,
      media_fatturato: 165000,
      fatturato_mese: 15000,
      incassato: 175000,
      classe_di_fatturato: "0-0.5M",
      mese_riferimento_dati_caricati: 12,
      anno_riferimento_dati_caricati: 2023,
    },
    monitoraggio: {
      prodotto: "Basic Monitoring",
      scadenza_monitoraggio: "2024-12-31",
      utenza: "basic@sistema.it",
    },
    credito_commerciale: {
      fido: 25000,
      fido_commerciale: 20000,
      fido_dinamico: 22000,
      fido_dinamico_medio: 21000,
      variazione_fido_commerciale_vs_dinamico_medio: 4.8,
      azione_da_fido_dinamico: "Mantenere",
      fido_2: null,
      esposizione: 8000,
      scaduto: 0,
      esposizione_su_fido_commerciale: 40.0,
      dso: 30,
      dso_medio: 28,
      bp_dso: 25,
      bp_dso_medio: 27,
      add: 22,
      add_medio: 24,
      limite_dso: 45,
      condizione_di_pagamento: "30 giorni data fattura",
      giorni_nominali: 30,
      codice_cliente_interno: "FORN004",
    },
    categorie_internal_use: {
      cat1: "Consulenza",
      cat2: "Professionale",
      cat3: "Locale",
      cat4: null,
      cat5: null,
      cat6: null,
      cat7: null,
      cat8: null,
    },
    pagamenti: {
      iban: "IT60X0542811101000000345678",
      sdi: "JKL3456",
      metodo_pagamento_preferito: "Bonifico bancario",
      note: "Consulente fiscale e tributario",
    },
    metadati: {
      fonte: "Portale Fornitori Privato",
      versione_schema: "1.1.0",
      data_creazione: "2023-04-05",
      data_ultima_modifica: "2023-12-01",
    },
  },
];

/**
 * Conversione dei dati dettagliati in formato semplificato per le liste
 */
export const FORNITORI_BASE: FornitoreBase[] = FORNITORI_DETTAGLIATI.map(
  (fornitore) => ({
    id: fornitore.id,
    ragioneSociale: fornitore.azienda.ragione_sociale,
    partitaIva: fornitore.operatore_economico.partita_iva,
    codiceFiscale: fornitore.operatore_economico.codice_fiscale_ditta,
    email: fornitore.azienda.email_pec,
    telefono: fornitore.azienda.telefono || undefined,
    cellulare: fornitore.referente_legale.telefono_1 || undefined,
    indirizzo: fornitore.azienda.indirizzo,
    cap: fornitore.azienda.cap,
    citta: fornitore.azienda.comune,
    provincia: fornitore.azienda.provincia,
    stato:
      fornitore.azienda.stato_attivita === "Attiva"
        ? "ATTIVO"
        : fornitore.azienda.stato_attivita === "Sospesa temporaneamente"
        ? "SOSPESO"
        : "ELIMINATO",
    tipologia: "AZIENDA",
    dataCreazione: `${fornitore.metadati.data_creazione}T10:30:00Z`,
    dataUltimaModifica: `${fornitore.metadati.data_ultima_modifica}T14:20:00Z`,
    pec: fornitore.azienda.email_pec,
    sdi: fornitore.pagamenti.sdi || undefined,
    iban: fornitore.pagamenti.iban || undefined,
    note: fornitore.pagamenti.note || undefined,
  })
);

/**
 * Dati lookup per le select
 */
export const LOOKUP_DATA: LookupData = {
  stati_fornitore: [
    { id: "ATTIVA", descrizione: "Attiva" },
    { id: "SOSPESO", descrizione: "Sospeso" },
    { id: "ELIMINATO", descrizione: "Eliminato" },
  ],
  forme_giuridiche: [
    { id: "SRL", descrizione: "Società a responsabilità limitata" },
    { id: "SPA", descrizione: "Società per azioni" },
    { id: "SNC", descrizione: "Società in nome collettivo" },
    { id: "SAS", descrizione: "Società in accomandita semplice" },
    { id: "SAPA", descrizione: "Società in accomandita per azioni" },
    {
      id: "SRLS",
      descrizione: "Società a responsabilità limitata semplificata",
    },
    { id: "IMPRESA_INDIVIDUALE", descrizione: "Impresa Individuale" },
    { id: "SOCIETA_COOPERATIVA", descrizione: "Società Cooperativa" },
    { id: "ALTRE_FORME", descrizione: "Altre Forme" },
  ],
  province: [
    { id: "Roma", descrizione: "Roma" },
    { id: "Milano", descrizione: "Milano" },
    { id: "Napoli", descrizione: "Napoli" },
    { id: "Torino", descrizione: "Torino" },
    { id: "Palermo", descrizione: "Palermo" },
  ],
};

/**
 * Dati per il menu di sistema
 */
export const MENU_ITEMS: MenuItem[] = [
  // {
  //   id: 1,
  //   nome: "Dashboard",
  //   label: "Dashboard",
  //   url: "/dashboard",
  //   icona: "bi-speedometer2",
  //   icon: "bi-speedometer2",
  //   ordine: 1,
  //   attivo: true,
  //   disabled: false,
  // },
  {
    id: 2,
    nome: "Fornitori",
    label: "Fornitori",
    url: "/fornitori",
    icona: "bi-people",
    icon: "bi-people",
    ordine: 1,
    attivo: true,
    disabled: false,
  },
  {
    id: 2,
    nome: "Gruppi Fornitori",
    label: "Gruppi Fornitori",
    url: "/gruppi-fornitori",
    icona: "bi-collection",
    icon: "bi-collection",
    ordine: 2,
    attivo: true,
    disabled: false,
  },
  {
    id: 3,
    nome: "Eventi",
    label: "Eventi",
    url: "/eventi",
    icona: "bi-calendar-event",
    icon: "bi-calendar-event",
    ordine: 3,
    attivo: false,
    disabled: true,
  },
  // {
  //   id: 4,
  //   nome: "Gare",
  //   label: "Gare",
  //   url: "/gare",
  //   icona: "bi-trophy",
  //   icon: "bi-trophy",
  //   ordine: 4,
  //   attivo: false,
  //   disabled: true,
  // },
  {
    id: 5,
    nome: "Contratti",
    label: "Contratti",
    url: "/contratti",
    icona: "bi-file-earmark-text",
    icon: "bi-file-earmark-text",
    ordine: 5,
    attivo: false,
    disabled: true,
  },
  {
    id: 6,
    nome: "Fatture",
    label: "Fatture",
    url: "/fatture",
    icona: "bi-receipt",
    icon: "bi-receipt",
    ordine: 6,
    attivo: false,
    disabled: true,
  },
  // {
  //   id: 7,
  //   nome: "Valutazioni",
  //   label: "Valutazioni",
  //   url: "/valutazioni",
  //   icona: "bi-star",
  //   icon: "bi-star",
  //   ordine: 7,
  //   attivo: false,
  //   disabled: true,
  // },
  // {
  //   id: 8,
  //   nome: "Report",
  //   label: "Report",
  //   url: "/report",
  //   icona: "bi-graph-up",
  //   icon: "bi-graph-up",
  //   ordine: 8,
  //   attivo: false,
  //   disabled: true,
  // },
  {
    id: 9,
    nome: "Notifiche",
    label: "Notifiche",
    url: "/notifiche",
    icona: "bi-bell",
    icon: "bi-bell",
    ordine: 9,
    attivo: false,
    disabled: true,
  },
  {
    id: 10,
    nome: "Impostazioni",
    label: "Impostazioni",
    url: "/impostazioni",
    icona: "bi-gear",
    icon: "bi-gear",
    ordine: 10,
    attivo: false,
    disabled: true,
  },
];

/**
 * Dati mock per i gruppi fornitori
 */
export interface GruppoFornitore {
  id: number;
  nome: string;
  descrizione: string;
  numero_fornitori: number;
  fornitori_ids: number[];
  data_creazione: string;
  data_modifica: string;
}

export const GRUPPI_FORNITORI: GruppoFornitore[] = [
  {
    id: 1,
    nome: "Fornitori Strategici",
    descrizione: "Fornitori con contratti a lungo termine e volumi elevati",
    numero_fornitori: 3,
    fornitori_ids: [1, 2, 3],
    data_creazione: "2024-01-15",
    data_modifica: "2024-12-10",
  },
  {
    id: 2,
    nome: "Fornitori IT",
    descrizione: "Fornitori di servizi informatici e tecnologici",
    numero_fornitori: 2,
    fornitori_ids: [2, 3],
    data_creazione: "2024-02-20",
    data_modifica: "2024-11-28",
  },
  {
    id: 3,
    nome: "Fornitori Logistica",
    descrizione: "Fornitori di servizi di trasporto e logistica",
    numero_fornitori: 2,
    fornitori_ids: [1, 4],
    data_creazione: "2024-03-10",
    data_modifica: "2024-12-05",
  },
  {
    id: 4,
    nome: "Fornitori Marketing",
    descrizione: "Agenzie di marketing, comunicazione e pubblicità",
    numero_fornitori: 2,
    fornitori_ids: [1, 2],
    data_creazione: "2024-04-05",
    data_modifica: "2024-12-01",
  },
  {
    id: 5,
    nome: "Fornitori Edilizia",
    descrizione: "Fornitori di materiali e servizi per l'edilizia",
    numero_fornitori: 1,
    fornitori_ids: [3],
    data_creazione: "2024-05-12",
    data_modifica: "2024-11-15",
  },
  {
    id: 6,
    nome: "Fornitori Consulenza",
    descrizione: "Consulenti fiscali, legali e aziendali",
    numero_fornitori: 2,
    fornitori_ids: [4, 2],
    data_creazione: "2024-06-18",
    data_modifica: "2024-12-08",
  },
  {
    id: 7,
    nome: "Fornitori Energia",
    descrizione: "Fornitori di energia elettrica, gas e servizi utilities",
    numero_fornitori: 1,
    fornitori_ids: [1],
    data_creazione: "2024-07-22",
    data_modifica: "2024-11-30",
  },
  {
    id: 8,
    nome: "Fornitori Manutenzione",
    descrizione: "Fornitori di servizi di manutenzione e facility management",
    numero_fornitori: 2,
    fornitori_ids: [3, 4],
    data_creazione: "2024-08-30",
    data_modifica: "2024-12-12",
  },
];

